export default __webpack_public_path__ + "3cb5460bbbb4096a8bc1d9bfaa8eab69.png";